import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import styles from './ModalFooter.module.sass';

const ModalFooter = ({
    children,
    size,
    info
}: Props) => {
    return <div className={`
        ${styles['modal__footer']}
        ${styles['modal__footer__size--'+(size||'medium')]}
    `}>
        { info && <div className={styles['modal__footer-info']}>
            { info }
        </div>}
        <div className={styles['modal__footer-content']}>
            { children }
        </div>
    </div>
}

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    info?: any
    size?: any
}

export default ModalFooter;